/* global System */
// register component(s) with react habitat

export default {
  IntroLogoBanner: () =>
    System.import(
      /* webpackChunkName: "IntroLogoBanner" */
      './Component'
    ),
}
